import { DrawingAppliance } from '~/core/models/drawing-appliance.model';
import {
  CornerMap,
  DrawingEdge,
  RemovedElementsHistory,
} from '~/core/models/drawing-shape.model';
import { EdgeModel } from '~/core/models/edge.model';
import { Skeleton } from '~/core/models/skeleton.model';

/**
 * Interface for what should be a explicitly serializable DrawingShape
 * CornerMap, DrawingEdge, and RemovedEdlementHistory must be made serializable as well
 */
export interface ISerializableDrawingShape {
  appliances: DrawingAppliance[];
  cornerMap: CornerMap;
  counterLabel?: number;
  drawingEdges: DrawingEdge[];
  edge?: EdgeModel;
  label?: string;
  /** tracks every edge that's not a "finished edge" */
  removedElementsHistory?: RemovedElementsHistory;
  skeleton: Skeleton;
  establishedLetterStartIndex?: number;
}

export const createSerializableDrawingShape = (
  props: ISerializableDrawingShape
): ISerializableDrawingShape => ({
  appliances: props.appliances ?? [],
  cornerMap: props.cornerMap ?? {},
  counterLabel: props.counterLabel,
  drawingEdges: props.drawingEdges ?? [],
  edge: props.edge,
  label: props.label,
  removedElementsHistory: props.removedElementsHistory,
  skeleton: props.skeleton ?? {},
  establishedLetterStartIndex: props.establishedLetterStartIndex,
});
